



































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";
import Add from "./shutdowns_add.vue";
import Edit from "./shutdowns_edit.vue";

@Component({
  components: {
    SelectStadium,
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  shutdownsType = [{ id: "0", name: "节日" }, { id: "1", name: "补班" }, { id: "2", name: "假日" }];

  dispatchType: string = "shutdowns/list";
  dispatchTypeDelete: string = "shutdowns/delete";

  columns = [
    {
      title: "编号",
      dataIndex: "id"
    },
    { title: "名称", dataIndex: "name" },
    { title: "类型", scopedSlots: { customRender: "type" } },
    { title: "sn", dataIndex: "sn" },
    { title: "开始时间", dataIndex: "shutdown_start" },
    { title: "结束时间", dataIndex: "shutdown_end" },
    { title: "天数", dataIndex: "shutdown_count" },
    { title: "场馆", scopedSlots: { customRender: "stadium_name" } },
    { title: "录入时间", dataIndex: "created_time" },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData();
  }
}
